import { makeStyles, Typography } from "@material-ui/core"
import React, { FC, useState } from "react"
import { PrimaryPortalButton } from "../atoms/button/Button"
import PlusIcon from "../atoms/PlusIcon"
import ClientTable from "../molecules/ClientTable"
import AddClientDialog from "../molecules/AddClientDialog"
import InviteClientDialog from "../molecules/InviteClientDialog"
import { HeaderHeight } from "../molecules/Header"
import { colors } from "../../utils/theme"
import {
  useAppInsightsContext,
  useTrackEvent,
} from "@microsoft/applicationinsights-react-js"
import { useUser } from "../../hooks/useUser"

const useStyles = makeStyles((theme) => ({
  myClients: {
    padding: theme.spacing(3),
    paddingTop: HeaderHeight + theme.spacing(3),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    backgroundColor: colors.neutral.white,
    flex: 1,
  },
  content: {
    maxWidth: 1440,
    margin: "0 auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(3),
  },
  title: {
    marginRight: theme.spacing(2),
  },
  addClientButton: {
    width: 188,
  },
}))

const MyClients: FC = () => {
  const classes = useStyles()
  const { user } = useUser()
  let userOrgId = "none"
  if (user?.organizations) {
    userOrgId = `${user?.organizations[0].id}-${user?.organizations[0].name}`
  }
  const [openInviteClient, setOpenInviteClient] = useState<boolean>(false)
  const [openAddClientDialog, setOpenAddClientDialog] = useState<boolean>(false)
  const appInsights = useAppInsightsContext()
  const trackAddClientToggle = useTrackEvent(appInsights, "Add Client", {
    org: "",
  })
  return (
    <>
      <div className={classes.myClients}>
        <div className={classes.content}>
          <div className={classes.header}>
            <Typography variant="h2" component="h1" className={classes.title}>
              Clients
            </Typography>
            <PrimaryPortalButton
              className={classes.addClientButton}
              onClick={() => {
                trackAddClientToggle({ org: userOrgId })
                setOpenAddClientDialog(true)
              }}
            >
              <PlusIcon />
              {"Add Client"}
            </PrimaryPortalButton>
            <PrimaryPortalButton
              className={classes.addClientButton}
              onClick={() => {
                setOpenInviteClient(true)
              }}
              style={{ marginLeft: "10px" }}
            >
              <PlusIcon />
              {"Invite Client"}
            </PrimaryPortalButton>
          </div>
          <ClientTable />
        </div>
      </div>

      <AddClientDialog
        open={openAddClientDialog}
        onClose={() => setOpenAddClientDialog(false)}
      />
      <InviteClientDialog
        open={openInviteClient}
        onClose={() => setOpenInviteClient(false)}
      />
    </>
  )
}

export default MyClients
